import React, { useState } from "react";
import "./App.css";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import { Signup } from "./features/auth/signup";
import { Login } from "./features/auth/login";
import { VerifyEmail } from "./features/auth/verify-email";
import { ResetPassword } from "./features/auth/reset-password";
import { Authenticated } from "./features/auth/authenticated";
import { AuthProvider } from "./features/auth/auth-provider";
import { Overview } from "./features/overview/overview";
import { Navigation } from "./features/navigation/navigation";
import { MatchGame } from "./features/match-game/match-game";
import { MenuModal } from "./features/navigation/menu-modal";

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AppContainer />}>
            <Route index element={<Overview />} />
            <Route path="games/:id" element={<MatchGame />} />
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

const AppContainer = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Authenticated>
      <div>
        {modalOpen ? <MenuModal dismiss={() => setModalOpen(false)} /> : null}
        <Navigation
          openMenu={() => {
            setModalOpen(true);
          }}
        />
        <Outlet />
      </div>
    </Authenticated>
  );
};

export default App;
